import { AxiosError, AxiosRequestConfig } from 'axios';
import { IBodyPills, IPills, IUpdatePills } from '../types/pills';
import { apiGet, apiPut } from './api';

const { REACT_APP_CATALOG } = process.env;

const getCategoryPills = async (categoryId: string | number): Promise<IPills> => {
  return apiGet<AxiosRequestConfig, IPills>(`${REACT_APP_CATALOG}pill-category/backoffice/${categoryId}`)
    .then(resp => {
      const pillsList: IPills = resp;
      return pillsList;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const updatePills = async (categoryId: string | number, body: IBodyPills): Promise<IUpdatePills> => {
  return apiPut<AxiosRequestConfig, IBodyPills>(`${REACT_APP_CATALOG}pill-category/backoffice/${categoryId}`, body)
    .then(resp => {
      const updatePills: IUpdatePills = resp;
      return updatePills;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};
export { getCategoryPills, updatePills };
